class LiveCounter {
    constructor(gameId = null, addChat = false) {
        this.connectionManager = app.connectionManager;
        this.config = app.config;
        this.hasHandler = false;
        this.active = false;
        this.counters = [];
        this.type = "none";
        this.source = "none";
        this.id = null;
        this.counterRoot = null;
        this.currentStart = 0;
        this.currentId = 0;
        this.connector = null;
        this.handler = null;
        if (gameId) {
            this.gameId = gameId;
        } else {
            this.gameId = null;
        }
        if (!this.hasHandler && this.connectionManager) {
            this.hasHandler = true;
            if (addChat) {
                app.chatWrapper.add("website", "none");
            }
            this.connectionManager.addListener(this);
            this.handler = this.connectionManager.addHandler(this.terminal.bind(this), "live-counter");
        }
    }

    init(type, source, id, initData) {
        this.type = type;
        this.source = source;
        this.id = id;
        switch (type) {
            case "bar":
                this.counterRoot = $("#live-counter-bar");
                break;

            case "top_list":
                this.counterRoot = $("#live-counter-top-list");
                break;
        }

        if (this.type === "bar") {
            setInterval(() => {
                this.rotatePrizes();
            }, 3000);
        }
        if (initData) {
            for (let i in initData) {
                this.processData(initData[i]);
            }
        }
    }

    onConnected() {
        return true;
    }

    onDisconnected() {
        return true;
    }

    terminal(message) {
        const data = app.util.jsonDecode(message.getElementsByTagName("body")[0].innerHTML).data;
        if (data.action === "update") {
            if (data.state === "running") {
                app.notifications.addToArea("missions", 1);
            }
            let root = $("#game-" + data.game_id);
            if (root.length) {
                let button = $("#shared_mission_button_" + data.id);
                if (button.length) {
                    button.attr("data-state", data.state);
                } else {
                    let template = $("#shared_mission_button_template");
                    let clone = template.clone();
                    clone.attr("id", "shared_mission_button_" + data.id);
                    clone.attr("data-id", data.id);
                    clone.attr("title", data.name);
                    clone.attr("data-state", data.state);
                    template.after(clone);
                }
            }
        } else {
            for (let i in data) {
                this.processData(data[i]);
            }
        }

        return true;
    }

    processData(data) {
        if (this.determine(data)) {
            if (this.active === false) {
                $("loading").remove();
                this.active = true;
            }
            switch (this.type) {
                case "bar":
                    this.updateBar(data);
                    break;

                case "top_list":
                    this.updateTopList(data);
                    break;
            }
        }
    }

    determine(data) {
        let state = false;
        switch (this.source) {
            case "game_id":
                if (data.g === this.id) {
                    state = true;
                }
                break;

            case "created_by":
                if (data.c === this.id) {
                    state = true;
                }
                break;

            case "id":
                if (this.id === data.id) {
                    state = true;
                }
                break;
        }
        if (state) {
            if (data.st < this.currentStart) {
                return false;
            }
            this.currentStart = data.st;
            return true;
        }

        return false;
    }

    initBar(data) {
        let counter = this.counterRoot.find("#bar-template").clone();
        counter.attr("id", "live-counter-bar-" + data.id);
        counter.addClass(data.th);
        counter.addClass(data.ty);
        counter.objective = counter.find(".live-counter-objective");
        counter.amount = counter.find(".live-counter-amount");
        counter.prize = counter.find(".live-counter-prize");
        counter.prizeWrapper = counter.prize.find(".wrapper");
        counter.prizeIndex = 0;
        counter.prizeCount = 0;
        counter.prizes = data.p;
        counter.progressBar = counter.find(".live-counter-progress");
        counter.progressBarBar = counter.progressBar.find(".progress-bar");
        counter.progressBarPercentage = counter.progressBar.find(".percentage");
        counter.progressBarAmount = counter.progressBar.find(".amount");
        counter.objective.html(data.o);
        counter.topListCounter = [];
        counter.topListBuyers = [];
        let code = $(counter).find("#code > #text");
        if (code.length) {
            code.html(data.pa);
        }
        this.counters[data.id] = counter;
        this.currentId = data.id;
        this.counterRoot.append(counter);
        setTimeout(() => {
            this.counters[data.id].css({top: 0});
        }, 10);
        return counter;
    }

    updateBar(data) {
        if (data.id) {
            let counter = null;
            let updateDuration = 15250;
            if (!this.counters[data.id]) {
                for (let i in this.counters) {
                    this.counters[i].css({top: "-100vh"});
                    setTimeout(() => {
                        this.counters[i].remove();
                        delete this.counters[i];
                    }, 2000);
                }
                updateDuration = 200;
                counter = this.initBar(data);
            } else {
                counter = this.counters[data.id];
            }
            this.updatePrize(data, counter);
            counter.objective.html(data.o);
            if (data.s === "running" || data.s === "ended") {
                switch (data.ty) {
                    case "two_random_teams":
                        this.updateTeamBar(counter, data.ad, 1000);
                        break;

                    case "endurance":
                        this.updateEnduranceBar(counter, data.a, Math.round((100 - (data.tl / (data.tp + data.tl) * 100)) * 100) / 100, 1000);
                        break;
                    case "reach_target":
                    case "reach_target_before_end":
                        this.updateBarItems(counter, data.a, data.t, false, updateDuration);
                        break;
                }
            } else if (data.s === "processing") {
                if (counter.state !== data.s) {
                    counter.state = data.s;
                    counter.addClass("pulsate-fast");
                    this.resetBar(counter);
                }
                if (typeof data.pa !== "undefined" && typeof data.pc !== "undefined") {
                    this.updateBarItems(counter, data.pc, data.pa, true);
                }
            } else if (data.s === "completed") {
                if (counter.state !== data.s) {
                    counter.state = data.s;
                    counter.removeClass("pulsate-fast");
                    counter.addClass("pulsate-slow");
                    this.resetBar(counter);
                }
                switch (data.ty) {
                    case "two_random_teams":
                        this.updateTeamBar(counter, data.ad, 1000);
                        break;

                    case "endurance":
                        this.updateEnduranceBar(counter, data.a, 100, 1000);
                        break;
                    case "reach_target":
                    case "reach_target_before_end":
                        this.updateBarItems(counter, data.a, data.t, false, 1000);
                        break;
                }

            }
        }
    }

    initToplist(data) {
        let counter = this.counterRoot.find("#toplist-template").clone();
        counter.attr("id", "live-counter-top-list-" + data.id);
        counter.addClass(data.th)
        counter.topListCounter = [];
        this.counters[data.id] = counter;
        this.counterRoot.append(counter);
        if (data.ty === "endurance" || data.ty === "reach_target_before_end" || data.ty === "two_random_teams") {
            let countdownBar = document.querySelector('#live-counter-top-list-' + data.id + ' .top-list-timer .bar');
            let percentage = 100;
            if (data.tl > 0) {
                let tickCallback = (remainingSeconds) => {
                    percentage = (((data.e - data.st) - remainingSeconds) / (data.e - data.st)) * 100;
                    countdownBar.style.width = Math.min(percentage, 100) + '%';
                };

                new Countdown('live-counter-top-list-' + data.id + ' .top-list-timer .time', data.e,
                    () => {
                        $('#live-counter-top-list-' + data.id + ' .top-list-timer').addClass("time-reached");
                        $('#live-counter-top-list-' + data.id + ' .top-list-timer .time').html(app.config.translate.ended);
                    }, tickCallback
                );
            } else {
                $('#live-counter-top-list-' + data.id + ' .top-list-timer').addClass("time-reached");
                $('#live-counter-top-list-' + data.id + ' .top-list-timer .time').html(app.config.translate.ended);
            }
        }

        return counter;
    }

    updateTopList(data) {
        if (data.id) {
            let counter;
            if (!this.counters[data.id]) {
                for (let i in this.counters) {
                    this.counters[i].find(".top-list-counter > div").attr("data-position", 0);
                    this.counters[i].find(".top-list-counter").delay(500).animate({opacity: 0});
                    setTimeout(() => {
                        this.counters[i].remove();
                        delete this.counters[i];
                    }, 2000);
                }
                counter = this.initToplist(data);
            } else {
                counter = this.counters[data.id];
            }
            if (counter && data.l) {
                counter.find(".top-list-counter > div").attr("data-position", 0);
                for (let i in data.l) {
                    if (typeof counter.topListCounter[data.l[i].u] !== "object") {
                        if (i <= 10 || (this.config.user && data.l[i].u === this.config.user.id)) {
                            if (data.l[i].te) {
                                let team = data.l[i].te === 1 ? "certificate" : "moon";
                                counter.topListCounter[data.l[i].u] = $('<div data-position="0" data-is-current-user="' + ((this.config.user && data.l[i].u === this.config.user.id) ? "true" : "false") + '" data-site="' + data.l[i].s + '"><span class="username"><i class="fa fas fa-' + team + ' mr-1"></i>' + data.l[i].us + '</span><div class="amount"><span class="value"></span><span class="percent"></span></div></div>');
                            } else {
                                counter.topListCounter[data.l[i].u] = $('<div data-position="0" data-is-current-user="' + ((this.config.user && data.l[i].u === this.config.user.id) ? "true" : "false") + '" data-site="' + data.l[i].s + '"><span class="username">' + data.l[i].us + '</span><div class="amount"><span class="value"></span><span class="percent"></span></div></div>');
                            }
                            counter.find(".top-list-counter").append(counter.topListCounter[data.l[i].u]);
                            setTimeout(() => {
                                if (typeof counter.topListCounter[data.l[i].u] === "object") {
                                    counter.topListCounter[data.l[i].u].attr("data-position", i);
                                    counter.topListCounter[data.l[i].u].find(".amount .value").html(data.l[i].a.toLocaleString(app.config.locale));
                                    if (data.hp) {
                                        let amount = data.a;
                                        if (data.ad) {
                                            for (let ix in data.ad) {
                                                amount += data.ad[ix];
                                            }
                                        }
                                        if (amount > 0 && data.l[i].a > 0) {
                                            counter.topListCounter[data.l[i].u].find(".amount .percent").html((Math.round(data.l[i].a / amount * 10000) / 100) + "%");
                                        } else {
                                            counter.topListCounter[data.l[i].u].find(".amount .percent").html("0.00%");
                                        }
                                    } else {
                                        counter.topListCounter[data.l[i].u].find(".amount .percent").remove();
                                    }
                                }
                            }, 1);
                        }
                    } else {
                        counter.topListCounter[data.l[i].u].attr("data-position", i);
                        if (i <= 10 || (this.config.user && data.l[i].u === this.config.user.id)) {
                            app.util.counter(counter.topListCounter[data.l[i].u].find(".amount .value")[0], data.l[i].a, 1000, false, 0);
                            if (data.hp) {
                                let amount = data.a;
                                if (data.ad) {
                                    for (let ix in data.ad) {
                                        amount += data.ad[ix];
                                    }
                                }
                                if (amount > 0 && data.l[i].a > 0) {
                                    counter.topListCounter[data.l[i].u].find(".amount .percent").html((Math.round(data.l[i].a / amount * 10000) / 100) + "%");
                                }
                            }
                        } else {
                            setTimeout(() => {
                                if (typeof counter.topListCounter[data.l[i].u] === "object") {
                                    counter.topListCounter[data.l[i].u].remove();
                                    delete counter.topListCounter[data.l[i].u];
                                }
                            }, 1000);
                        }
                    }
                }
            }
        }
    }

    updatePrize(data, counter) {
        let prizeCount = 0;
        for (let prize in data.p) {
            prizeCount++;
        }
        if (prizeCount !== counter.prizeCount) {
            counter.prizeWrapper.html("");
            counter.prizeCount = prizeCount;
            for (let prize in data.p) {
                counter.prizeWrapper.append("<div id='" + prize + "'><span class='target'>" + data.p[prize].t + "</span><span class='amount'>" + parseInt(data.p[prize].a).toLocaleString(this.config.locale) + "</span><img src='" + data.p[prize].i + "'></div>")
            }
        } else {
            for (let prize in data.p) {
                counter.prize.find(".wrapper #" + prize).html("<span class='target'>" + data.p[prize].t + "</span><span class='amount'>" + parseInt(data.p[prize].a).toLocaleString(this.config.locale) + "</span><img src='" + data.p[prize].i + "'>");
            }
        }
    }

    rotatePrizes() {
        let counter = this.counters[this.currentId];
        if (typeof counter != "undefined" && counter.prizeCount > 1) {
            counter.prize.find(".wrapper").css({top: -(++counter.prizeIndex % counter.prizeCount * 100) + "%"});
        }
    }

    updateBarItems(counter, amount, target, asDivided = false, duration = 5250) {
        app.util.counter(counter.amount[0], amount, duration, false, 0, true, (value) => {
            if (target) {
                counter.percentage = (value / target) * 100;
                counter.progressBarBar.css({width: counter.percentage + "%"});
                counter.progressBarPercentage.html(Math.floor(counter.percentage) + "%");
            } else {
                counter.progressBarBar.css({width: "100%"});
            }

            if (asDivided) {
                counter.progressBarAmount.html(value.toLocaleString(app.config.locale) + " / " + target.toLocaleString(app.config.locale));
            } else {
                counter.progressBarAmount.html(value.toLocaleString(app.config.locale));
            }
        });
    }

    updateEnduranceBar(counter, amount, percentDone, duration = 5250) {
        app.util.counter(counter.amount[0], amount, duration, false, 0, true, (value) => {
            counter.progressBarBar.css({width: percentDone + "%"});
            counter.progressBarPercentage.html(percentDone + "%");
            counter.progressBarAmount.html(value.toLocaleString(app.config.locale));
        });
    }

    updateTeamBar(counter, amount, duration = 5250) {
        if (!amount || (!amount.team_1 && !amount.team_2)) {
            return;
        }
        if (!amount.team_2) {
            counter.percentage = 100;
        } else if (!amount.team_1) {
            counter.percentage = 0;
        } else {
            counter.percentage = ((amount.team_1 / (amount.team_1 + amount.team_2)) * 100);
        }

        counter.progressBarBar.css({width: counter.percentage + "%"});
        if (counter.percentage === 50 && counter.progressBarPercentage.html().length < 1) {
            counter.progressBarPercentage.html(0);
        }
        if (counter.percentage > 50) {
            counter.progressBarPercentage.css({right: (100 - counter.percentage) + "%", textAlign: "right"});
        } else {
            counter.progressBarPercentage.css({left: counter.percentage + "%", textAlign: "left"});
        }
        app.util.counter(counter.amount[0], amount.team_1 - amount.team_2, duration, false, 0, true, (value) => {
            counter.progressBarPercentage.html(Math.abs(value).toLocaleString(app.config.locale));
        });
    }

    resetBar(counter) {
        app.util.clearCounter(counter.amount[0]);
        counter.amount.html("");
        counter.percentage = 0;
        counter.progressBarBar.css({width: 0 + "%"});
        counter.progressBarPercentage.html("");
    }

    destroy() {
        if (this.connectionManager && this.handler) {
            this.connectionManager.deleteHandler(this.handler);
        }
        delete this;
    }
}


